import { ServiceCenter } from 'containers/service-center';

export const ServisnyyCenter = () => {
	return <ServiceCenter />;
};
